<template>
    <b-col cols="12" class="filter-form mt-2">
        <b-card>
            <b-card-body>
                <b-card-title class="h6 p-1 text-center text-white">{{ $translate('filter') }}</b-card-title>
                <form class="form-sample filter-inner mb-4 p-0">
                    <!-- <b-row>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd">
                            <label class="mb-2"><strong> {{ $translate('activity_types') }}</strong></label>
                            <b-form-select class="form-control" v-model="orderFilter.type" value-field="id"
                                text-field="name" :options="orderTypes" value="">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('any_type') }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd officer-box">
                            <label class="mb-2"><strong> {{ $translate('officer') }}</strong></label>
                            <b-form-select class="form-control" id="input-officer" value-field="id" text-field="name"
                                v-model="orderFilter.driver_id" :options="officers">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('any_officer')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd">
                            <label class="mb-2"><strong> {{ $translate('activity_status') }}</strong></label>
                            <b-form-select class="form-control" id="input-status" v-model="orderFilter.status"
                                value-field="id" text-field="name" :options="status">
                                <template #first>
                                    <b-form-select-option :value="null">
                                        {{ $translate('select_status') }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="3" cols="12" class="mt-3 mt-md-0 dd">
                            <label class="mb-2"><strong> {{ $translate('category') }}</strong></label>
                            <b-form-select class="form-control" id="input-activity-category"
                                v-model="orderFilter.request_category_id" value-field="id" text-field="name"
                                :options="categories" :disabled="false">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_activity_category')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row> -->
                    <b-row>
                        <b-col cols="12" class="mt-3">
                            <label for="user-input" class="mb-3"><strong>{{ $translate('review_type') }}</strong></label>
                            <b-form-select class="form-control" id="user-input" v-model="model.type"
                                :options="filteredTypes" text-field="name" value-field="id" trim>
                                <template #first>
                                    <b-form-select-option value="">{{
                                        $translate('select_review_type')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" cols="12" class="mt-3">
                            <label class="mb-2" for="input-from"><strong> {{ $translate('due_from') }}</strong></label>
                            <div class="filter-date">
                                <input type="date" class="form-control" id="input-from" v-model="model.from"
                                    :max="model.to" />
                            </div>
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3">
                            <label class="mb-2" for="input-to"><strong> {{ $translate('due_to') }}</strong></label>
                            <div class="filter-date">
                                <input type="date" class="form-control" id="input-to" v-model="model.to"
                                    :min="model.from" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" cols="12" class="mt-3 dd">
                            <label class="mb-2" for="input-status"><strong> {{ $translate('review_status')
                            }}</strong></label>
                            <b-form-select class="form-control" :options="status" value-field="id" text-field="label"
                                id="input-status" v-model="model.status">
                                <template #first>
                                    <option value="">{{ $translate('select_status') }}</option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3 dd">
                            <label class="mb-2" for="input-activityStatus"><strong> {{ $translate('activity_status')
                            }}</strong></label>
                            <b-form-select class="form-control" :options="activityStatus" value-field="id"
                                text-field="label" id="input-activityStatus" v-model="model.activity_status">
                                <template #first>
                                    <option value="">{{ $translate('select_activity_status') }}</option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" cols="12" class="mt-3 dd">
                            <label class="mb-2" for="input-review_officer"><strong> {{ $translate('review_officer')
                            }}</strong></label>
                            <b-form-select class="form-control" :options="officers" value-field="id" text-field="name"
                                id="input-review_officer" v-model="model.review_officer">
                                <template #first>
                                    <option value="">{{ $translate('select_review_officer') }}</option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="6" cols="12" class="mt-3 dd">
                            <label class="mb-2" for="input-activity_officer"><strong> {{ $translate('activity_officer')
                            }}</strong></label>
                            <b-form-select class="form-control" :options="officers" value-field="id" text-field="name"
                                id="input-activity_officer" v-model="model.activity_officer">
                                <template #first>
                                    <option value="">{{ $translate('select_activity_officer') }}</option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </form>
            </b-card-body>
        </b-card>
    </b-col>
</template>

<script>
export default {
    name: 'orders-queryfilters',
    props: [
        "model",
        "status",
        "activityStatus",
        'officers',
        "filteredTypes",
    ],
    data() {
        return {}
    },
    watch: {
        'model.checkoffTypeId': {
            handler: function (val) {
                this.$emit('getReviewTypeId', val);
            }
        }
    }
}
</script>

